import axios from './config/config-viva'

const defaultRoute = 'pagamentos/'

export default {
  findAll: () => {
    return axios.get(`${defaultRoute}`)
  },
  findCashierReport: (caixaId, date=null) => {
    return axios.get(`${defaultRoute}caixa-report/${caixaId}${date?'?date='+date:''}`)
  },
  findCashierReportAll: (date=null) => {
    return axios.patch(`${defaultRoute}caixa-report-all${date?'?date='+date:''}`)
  },
  cashierDiaryOperations: (caixaId, date=null) => {
    return axios.get(`${defaultRoute}caixa-diary/?caixa=${caixaId}${date?'&date='+date:''}`)
  },
  findCashierReportGeralByPeriod: async (caixaId, startDate, endDate) => {
    const response = await axios.get(`${defaultRoute}caixa-report-geral-by-period`, {
      params: {
        caixaId,
        startDate,
        endDate
      }
    })

  return response.data
  },
  findCashierReportGeral: (date=null, caixaId=null) => {
    return axios.get(`${defaultRoute}caixa-report-geral/?cashier=null${date?'&date='+date:''}${caixaId?'&caixaId='+caixaId:''}`)
  },
  list: (tipo, filter, dataInicial=null, dataFinal=null, tipoPesquisa=null, caixa, type=null) => {
    return axios.get(
        `${defaultRoute}busca?tipo=${tipo}${
          filter ? '&filter=' + filter : ''
        }${dataInicial ? '&data_inicial=' + dataInicial : ''}${
          dataFinal ? '&data_final=' + dataFinal : ''
        }${tipoPesquisa ? '&type=' + tipoPesquisa : ''}${
          caixa ? '&caixa=' + caixa : ''
        }${
          type ? '&type=' + type : ''
        }`
      )
  },
  findOneByFilter: (cliente, parcela) => {
    return axios.get(`${defaultRoute}oneFilter?cliente=${cliente}&parcela=${parcela}`)
  },
  getSituacao(cliente, dependente=null){
    return axios.get(`${defaultRoute}situacao?cliente=${cliente}${dependente?'&dependente='+dependente:''}`)
  },
  create: (cliente) => {
    return axios.post(defaultRoute, cliente)
  },
  update: (id, user) => {
    return axios.put(defaultRoute+id, user)
  },
  remove: (id) => {
    return axios.delete(defaultRoute+id)
  },
  alterarInternacao: (cliente, acao, dependente=null) => {
    return axios.get(`${defaultRoute}internacao/${cliente}?acao=${acao}${dependente?'&dependente='+dependente:''}`)
  },
  withdrawBalance: (clientId, value) => {
    return axios.post(`${defaultRoute}withdraw-balance`, {clientId, value})
  },
}